import { createReducer } from '@ngrx/store';

export const extensionAppFeatureKey = 'extensionApp';

/**
 * The extension-app slice no longer mirrors `activeExtensionApp` from the Classroom Y.Doc —
 * consumers read directly from `ClassroomFacade` (via `ExtensionAppService`).
 *
 * The slice is kept as a minimal placeholder so the existing feature registration
 * (`StoreModule.forFeature(extensionAppFeatureKey, reducer)`) doesn't need to be torn down
 * across all apps. Add new local-only state here if a future feature needs it.
 */
export interface State {
    // intentionally empty
}

export const initialState: State = {};

export const reducer = createReducer<State>(initialState);
